import React from "react";

export const MoleculeBackground = () => {
  return (
    <div
      data-testid="molecule-background"
      className="absolute inset-0 overflow-hidden pointer-events-none"
      aria-hidden="true"
    >
      <svg className="absolute -top-24 -left-24 w-[420px] h-[420px] float-a opacity-[0.18]" viewBox="0 0 200 200">
        <g stroke="#A8FF3E" strokeWidth="0.6" fill="none">
          <circle cx="100" cy="100" r="6" fill="#A8FF3E" />
          <circle cx="40" cy="60" r="4" fill="#00C853" />
          <circle cx="160" cy="70" r="4" fill="#00C853" />
          <circle cx="150" cy="160" r="4" fill="#00C853" />
          <circle cx="50" cy="150" r="4" fill="#00C853" />
          <line x1="100" y1="100" x2="40" y2="60" />
          <line x1="100" y1="100" x2="160" y2="70" />
          <line x1="100" y1="100" x2="150" y2="160" />
          <line x1="100" y1="100" x2="50" y2="150" />
        </g>
      </svg>
      <svg className="absolute top-1/3 right-[-80px] w-[360px] h-[360px] float-b opacity-[0.14]" viewBox="0 0 200 200">
        <g stroke="#00C853" strokeWidth="0.6" fill="none">
          <circle cx="100" cy="100" r="5" fill="#00C853" />
          <circle cx="30" cy="100" r="3" fill="#A8FF3E" />
          <circle cx="170" cy="100" r="3" fill="#A8FF3E" />
          <circle cx="100" cy="30" r="3" fill="#A8FF3E" />
          <circle cx="100" cy="170" r="3" fill="#A8FF3E" />
          <line x1="100" y1="100" x2="30" y2="100" />
          <line x1="100" y1="100" x2="170" y2="100" />
          <line x1="100" y1="100" x2="100" y2="30" />
          <line x1="100" y1="100" x2="100" y2="170" />
        </g>
      </svg>
      <svg className="absolute bottom-[-80px] left-1/3 w-[300px] h-[300px] float-c opacity-[0.12]" viewBox="0 0 200 200">
        <g stroke="#FFB800" strokeWidth="0.5" fill="none">
          <circle cx="60" cy="60" r="4" fill="#FFB800" />
          <circle cx="140" cy="60" r="4" fill="#FFB800" />
          <circle cx="100" cy="140" r="4" fill="#FFB800" />
          <line x1="60" y1="60" x2="140" y2="60" />
          <line x1="60" y1="60" x2="100" y2="140" />
          <line x1="140" y1="60" x2="100" y2="140" />
        </g>
      </svg>
    </div>
  );
};

export default MoleculeBackground;
